import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from "rxjs";
import { FlatFileModel, FlatFilePreviewModel, EngagementMappingHeadersModel, SignflipParamModel } from '../models/flatfile.model';
import { tap } from 'rxjs/operators';
import { InfraService } from './infra.service';


@Injectable()
export class FlatfileService {
  private configUrl: string;
  private coreAPIUrl: string;
  private coreMappingAPIUrl: string;
  private coreDaisyAPIUrl: string;
  private loggedInUserId: number

  constructor(private infraService: InfraService, private http: HttpClient) {
    this.loggedInUserId = + localStorage.getItem('loggedInUserId');
    this.infraService.infraDetails$.subscribe(data => {
      this.configUrl = data.WebEndPoint1 + 'flatfile';
      this.coreAPIUrl = data.WebEndPoint2 + 'flatfile';
      this.coreMappingAPIUrl = data.WebEndPoint2 + 'MappingRemediation';
      this.coreDaisyAPIUrl = data.WebEndPoint2 + 'daiseydashboard';
    });

    if (!this.infraService.isInfraDetailsAvailable && localStorage.getItem('selectedInfra') != undefined) {
      this.infraService.isInfraDetailsAvailable = true;
      this.infraService.setInfraDetails(localStorage.getItem('selectedInfra'));
    }

  }


  //// added by tanmay tiwari on 14 jan 2019 for swapping mapping column data
  // public swapMappingData(mappingid1: number, mappingid2: number, engagementid: number) {

  //  return this.http.put(`${this.configUrl}/swapMappingData/${mappingid1}~${mappingid2}~${engagementid}`, {});
  //  // .catch(this.handleError);
  // }
  //// ends here

  public updatemappingwithsignflip(engagementId, signflipParamModel: SignflipParamModel[]) {
    return this.http.post(`${this.coreAPIUrl}/UpdateMappingwithSignflip`, { "EngagementId": engagementId, "SignflipParamModel": signflipParamModel });

  }

  public getflatfilestatus(engagementId: number) {
    return this.http.get(`${this.coreAPIUrl}/CheckFlatFileExist/${engagementId}`);
    // .catch(this.handleError);
  }

  public addFlatFileDownloadIntoQueue(engagementId: number, isTemplate: boolean = false) {
    return this.http.post(`${this.coreAPIUrl}/AddFlatFileDownloadToQueue/${engagementId}/${isTemplate}`, {});
    // .catch(this.handleError);
  }

  public addPowerBIFlatFileDownloadIntoQueue(engagementId: number) {
    return this.http.post(`${this.coreDaisyAPIUrl}/AddPowerBIFlatFileDownloadToQueue/${engagementId}`, {});
    // .catch(this.handleError);
  }

  public getflatfile(flatFileDownloadWebJobQueueId: number) {

    return this.http.get(`${this.coreAPIUrl}/DownloadFlatFileUsingQueue/${flatFileDownloadWebJobQueueId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public getflatfileTemplate(engagementId: number, isDatesInRowFormat: boolean) {

    return this.http.get(`${this.coreAPIUrl}/GetFlatFileTemplate/${engagementId}/${isDatesInRowFormat}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public getPowerBiflatfile(powerBiflatFileDownloadWebJobQueueId: number) {

    return this.http.get(`${this.coreDaisyAPIUrl}/DownloadPowerBiFlatFileUsingQueue/${powerBiflatFileDownloadWebJobQueueId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public getMappingfile(engagementId: number) {

    return this.http.get(`${this.coreMappingAPIUrl}/${engagementId}`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob'
    }).pipe(
      tap(
      )
    );
  }

  public generateMappingSuggestion(engagementId: number) {
    return this.http.post(`${this.coreAPIUrl}/PopulateSuggestionForFlatFile/${engagementId}`, {});
  }


  private handleError(error: Response) {
    return throwError(()=> error);
  }
}
